import type { SVGProps } from 'react';

/**
 * The chat speech-bubble glyph from the Claude Design "Chat icon redesign"
 * project (svg/chat-v7-solid-glyph.svg): 24x24, one evenodd path on
 * currentColor, so it takes the color and size of its parent like a lucide
 * icon does. The launcher wraps it in the tinted circle; the unread badge is a
 * CSS overlay on top, never part of the glyph.
 */
export function ChatGlyph(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 24 24'
      width='24'
      height='24'
      fill='currentColor'
      aria-hidden='true'
      focusable='false'
      {...props}
    >
      <path
        fillRule='evenodd'
        d='M8.5 3.5H15.5A5.5 5.5 0 0 1 21 9V11.5A5.5 5.5 0 0 1 15.5 17H10.8C10 17 9.2 17.3 8.6 17.9L6.5 20C5.6 20.9 4 20.3 4 19V9A5 5 0 0 1 8.5 3.5Z M8.5 9.1a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 1 0 0-2.3Zm4 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 1 0 0-2.3Zm4 0a1.15 1.15 0 1 0 0 2.3 1.15 1.15 0 1 0 0-2.3Z'
      />
    </svg>
  );
}
